import React from 'react'

const Spinner = (props: any) => {
  return (
    <div className='loader' style={{width: `${props.spinnerWidth}px`}}></div>
  )
}

export default Spinner